var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { AnsweringFeedback } from '../../../classes/question/modules/AnsweringFeedback';
export class AssociateAnsweringFeedback extends AnsweringFeedback {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get currentAssociation() {
        return this.question.currentAssociation;
    }
    get feedbackTime() {
        return 2000;
    }
    get feedbackText() {
        if (this.question.answeringState.isInFeedbackState) {
            return 'Fertig.';
        }
        if (this.question.answeringState.isInAnsweringState) {
            return this.feedbackTextAnswering;
        }
        return '';
    }
    get feedbackTextAnswering() {
        if (this.question.currentAssociation) {
            if (this.question.currentAssociation.isAssociationComplete) {
                return this.feedbackTextAssociationDone;
            }
            return this.feedbackTextAssociationInAction;
        }
        return '';
    }
    get feedbackTextAssociationDone() {
        if (this.currentAssociation.isCorrectlyAssociated) {
            return `Richtig! ${this.currentAssociation.remainingFeedbackTimeInSeconds}`;
        }
        return `Leider falsch. ${this.currentAssociation.remainingFeedbackTimeInSeconds}`;
    }
    get feedbackTextAssociationInAction() {
        return `Ordne zu! (${this.question.numberOfCurrentAssociation} von ${this.question.associationsToAsk.length})`;
    }
}
__decorate([
    override
], AssociateAnsweringFeedback.prototype, "feedbackText", null);
